import { Suspense, lazy } from "react";
import { createBrowserRouter } from "react-router-dom";

import { Spinner } from "@/ui/spinner";

import { ROUTERS } from "@/shared/constants/routers";

import { Layout } from "../ui/layout";

import { ProtectedRoute } from "./protected-route";

const ErrorPage = lazy(() => import("@/pages/error"));
const ExchangePage = lazy(() => import("@/pages/exchange"));
const FaqPage = lazy(() => import("@/pages/faq"));
const HistoryPage = lazy(() => import("@/pages/history"));
const HistoryReferralPaymentsPage = lazy(
  () => import("@/pages/history-referral-payments"),
);
const HistoryWithdrawalsPage = lazy(
  () => import("@/pages/history-withdrawals"),
);
const HomePage = lazy(() => import("@/pages/home"));
const OnboardingPage = lazy(() => import("@/pages/onboarding"));
const ProfilePage = lazy(() => import("@/pages/profile"));
const ReferralPage = lazy(() => import("@/pages/referral"));
const VerificationPage = lazy(() => import("@/pages/verification"));
const WithdrawalPage = lazy(() => import("@/pages/withdrawal"));

const routes = [
  {
    path: ROUTERS.ONBOARDING,
    children: [
      {
        path: ROUTERS.ONBOARDING,
        element: (
          <div className="relative m-auto flex min-h-dvh max-w-(--maxWidth) flex-col overflow-hidden">
            <Suspense fallback={<Spinner variant={"load"} size={"load"} />}>
              <OnboardingPage />
            </Suspense>
          </div>
        ),
      },
    ],
  },
  {
    path: ROUTERS.MAIN,
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: ROUTERS.MAIN,
        element: (
          <Suspense fallback={<Spinner variant={"load"} size={"load"} />}>
            <HomePage />
          </Suspense>
        ),
      },
      {
        path: ROUTERS.HISTORY,
        element: (
          <Suspense fallback={<Spinner variant={"load"} size={"load"} />}>
            <HistoryPage />
          </Suspense>
        ),
      },
      {
        path: ROUTERS.EXCHANGE,
        element: (
          <Suspense fallback={<Spinner variant={"load"} size={"load"} />}>
            <ExchangePage />
          </Suspense>
        ),
      },
      {
        path: ROUTERS.VERIFICATION,
        element: (
          <Suspense fallback={<Spinner variant={"load"} size={"load"} />}>
            <VerificationPage />
          </Suspense>
        ),
      },
      {
        path: ROUTERS.PROFILE,
        element: (
          <Suspense fallback={<Spinner variant={"load"} size={"load"} />}>
            <ProfilePage />
          </Suspense>
        ),
      },
      {
        path: ROUTERS.FAQ,
        element: (
          <Suspense fallback={<Spinner variant={"load"} size={"load"} />}>
            <FaqPage />
          </Suspense>
        ),
      },
      {
        path: ROUTERS.REFERRAL,
        element: (
          <Suspense fallback={<Spinner variant={"load"} size={"load"} />}>
            <ReferralPage />
          </Suspense>
        ),
      },
      {
        path: ROUTERS.WITHDRAWAL,
        element: (
          <Suspense fallback={<Spinner variant={"load"} size={"load"} />}>
            <WithdrawalPage />
          </Suspense>
        ),
      },
      {
        path: ROUTERS.HISTORY_REFERRAL_PAYMENTS,
        element: (
          <Suspense fallback={<Spinner variant={"load"} size={"load"} />}>
            <HistoryReferralPaymentsPage />
          </Suspense>
        ),
      },
      {
        path: ROUTERS.HISTORY_WITHDRAWALS,
        element: (
          <Suspense fallback={<Spinner variant={"load"} size={"load"} />}>
            <HistoryWithdrawalsPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: ROUTERS.ERROR,
    element: (
      <ProtectedRoute>
        <Suspense fallback={<Spinner variant={"load"} size={"load"} />}>
          <ErrorPage />
        </Suspense>
      </ProtectedRoute>
    ),
  },
];

export const router = createBrowserRouter(routes);
